module.exports = __webpack_public_path__ + "static/media/HQ18_Dr-Wallach@2x.a22f6b6e.png";